export const PUBLIC_MARKETING_COOKIE_CONSENT_KEY =
  "tkl_external_catalog_cookie_consent";

/** Fired on `window` after consent is saved (same tab). */
export const PUBLIC_MARKETING_COOKIES_ACCEPTED_EVENT =
  "tkl-public-marketing-cookies-accepted";

export function readPublicMarketingCookieConsent(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return (
      window.localStorage.getItem(PUBLIC_MARKETING_COOKIE_CONSENT_KEY) ===
      "accepted"
    );
  } catch {
    return false;
  }
}

/** Persists opt-in and notifies listeners (e.g. PublicGtm). Idempotent. */
export function grantPublicMarketingCookieConsent(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(PUBLIC_MARKETING_COOKIE_CONSENT_KEY, "accepted");
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(PUBLIC_MARKETING_COOKIES_ACCEPTED_EVENT));
}
